import { useState } from "react";
import { DCBaseProps } from "./DCBase";
import { Workflow } from "winslow-core";
import toast from "react-hot-toast";
import { toastFail, toastSuccess } from "../../../config";
import { useSelector } from "react-redux";
import { selectEditingCollection, selectUser } from "../../../redux/features/appData/appDataSlice";
import { useNavigate } from "react-router-dom";
import { AppWorkflow } from "../vibe-coder/AppWorkflow";


type DCWorkflowProps = DCBaseProps & {
    data: {
        workflowId: string;
    }
}

export const DCWorkflow = ({data, isOutdated, message}: DCWorkflowProps) => {

    const navigate = useNavigate();

    const storeUser = useSelector(selectUser);
    const editingCollection = useSelector(selectEditingCollection);

    console.log("[DCWorkflow] isOutdated: ", isOutdated);
    console.log("[DCWorkflow] data: ", data);

    return (
        <div className="dc-component-card">
            <AppWorkflow
                dynamicContext={{ workflowId: data.workflowId }}
                disabled={isOutdated}
            />

        </div>
    
    )
}